// extracted by mini-css-extract-plugin
export default {"sprite":"printButton_sprite__sqSyB","menu":"printButton_menu__Y+TsG","optionButton":"printButton_optionButton__rK0mz"};